module.exports = __webpack_public_path__ + "img/cloud-slash.ac6ca3b5.svg";